import React from "react";
import styles from "./ListVirtualTemplate.module.css";
import classNames from "classnames";
import VirtualScrollList from "rc-virtual-list";
import { useResizeDetector } from "react-resize-detector";
function ListVirtualTemplate({ classNameContainer, classNameContainerList, classNameList, header, ...props }) {
    const { height, ref: observableRef } = useResizeDetector();
    return (React.createElement("div", { className: classNames(styles.container, classNameContainer) }, header === null || header === void 0 ? void 0 :
        header(),
        React.createElement("div", { ref: observableRef, className: classNames(styles.list, classNameContainerList) },
            React.createElement(VirtualScrollList, { className: classNameList, height: height, ...props }))));
}
export default ListVirtualTemplate;
